// Получение записией
export const GET_BOOKING_SAGA = 'GET_BOOKING_SAGA';
// Регистрация пользователя
export const REGISTRATION_SAGA = 'REGISTRATION_SAGA';
// Проверка кода из письма
export const CHECK_EMAIL_CODE_SAGA = 'CHECK_EMAIL_CODE_SAGA';
// Восстановление пароля
export const RECOVERY_PASSWORD_SAGA = 'RECOVERY_PASSWORD_SAGA';
// Запрашиваем фильтры
export const GET_FILTERS_SAGA = 'GET_FILTERS_SAGA';
// Авторизация
export const SIGN_IN_SAGA = 'SIGN_IN_SAGA';
// Проверка хэша
export const CHECK_HASH_SAGA = 'CHECK_HASH_SAGA';
// Получение абонементов пользователя
export const GET_SUBSCRIPTIONS_SAGA = 'GET_SUBSCRIPTIONS_SAGA';
// Записть на групповое занятие / отмена
export const BOOKING_ACTION_SAGA = 'BOOKING_ACTION_SAGA';
// Получение списка услуг
export const GET_SERVICES_SAGA = 'GET_SERVICES_SAGA';
// Поулчение списка мастеров
export const GET_MASTERS_SAGA = 'GET_MASTERS_SAGA';
// Получение даты и времени для записи
export const GET_TIMETABLE_SAGA = 'GET_TIMETABLE_SAGA';
// Сохранение записи на услугу
export const ADD_SCHEDULE_RESERVE_SAGA = 'ADD_SCHEDULE_RESERVE_SAGA';
// Получение списка записей на услуги
export const GET_MY_RESERVES_SAGA = 'GET_MY_RESERVES_SAGA';
// Удаление записи на услугу
export const REMOVE_RESERVE_SAGA = 'REMOVE_RESERVE_SAGA';
// Получение информации о тренере
export const GET_COACH_INFO_SAGA = 'GET_COACH_INFO_SAGA';